import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Container, Typography, Box, Card, CardContent, Grid,
  Chip, Button, CircularProgress
} from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import coursesService from '../../services/courses.service';

const statusColors = {
  pending: 'warning', shopping: 'info', purchased: 'primary',
  delivering: 'primary', delivered: 'success', cancelled: 'error'
};

const CoursesOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    coursesService.getMyOrders()
      .then(data => setOrders(data.orders || []))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh"><CircularProgress /></Box>;

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h3" fontWeight={700}>Mes courses</Typography>
          <Button component={Link} to="/courses" variant="contained" startIcon={<ShoppingCartIcon />}>
            Nouvelle commande
          </Button>
        </Box>
      </Box>

      {orders.length === 0 ? (
        <Card><CardContent sx={{ textAlign: 'center', py: 6 }}>
          <ShoppingCartIcon sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h6" color="text.secondary">Aucune commande</Typography>
          <Button component={Link} to="/courses" variant="contained" sx={{ mt: 2 }}>Commander</Button>
        </CardContent></Card>
      ) : (
        <Grid container spacing={3}>
          {orders.map((order) => (
            <Grid item xs={12} key={order.id}>
              <Card>
                <CardContent>
                  <Box display="flex" justifyContent="space-between" mb={2}>
                    <Box>
                      <Typography variant="h6">Commande #{order.order_number}</Typography>
                      <Typography variant="body2">{order.store_name}</Typography>
                    </Box>
                    <Chip label={order.order_status} color={statusColors[order.order_status] || 'default'} />
                  </Box>
                  <Typography variant="body2" color="text.secondary" paragraph sx={{ whiteSpace: 'pre-line' }}>
                    {order.shopping_list}
                  </Typography>
                  <Typography variant="h6" color="primary">
                    {order.total_amount || order.delivery_fee + order.service_fee} €
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  );
};

export default CoursesOrders;
